import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/views/App";
import { initSensors } from "@/plugin/sensors";
import "@/api/socketIOManager";

import "@/views/styles/tailwind.css";
// 迁移期间继续加载 Vue 版本的全局工具类、基础主题和图标字体，保证转换后的页面不丢失公共样式。
import "@/assets/css/common.scss";
import "@/assets/css/_flex.scss";
import "@/assets/css/_spacing.scss";
import "@/assets/css/_grid.scss";
import "@/assets/css/element.scss";
import "@/assets/css/base.scss";
import "@/assets/css/fonts.scss";
import "@/assets/iconfont/iconfont.css";
import "@/views/styles/page-styles.scss";
import "zhihao-ui-react/style.css";
// 全局列表筛选、日期范围和分页视觉契约，统一覆盖所有 React 列表页。
import "@/styles/index.css";

/** 清理旧版应用缓存，避免部署后继续读取过期静态资源。 */
const clearCaches = async () => {
    if (!("caches" in window)) {
        return;
    }
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
};

initSensors();
void clearCaches();

const rootElement = document.getElementById("root");

if (!rootElement) {
    throw new Error("未找到 React 应用挂载节点 #root");
}

createRoot(rootElement).render(
    <StrictMode>
        <App />
    </StrictMode>
);
